import BindPhone from './src/main'

export default {
  install(Vue, props) {
    Vue.prototype.$BindPhone = options => BindPhone(options, props)
  }
}
